import { render, staticRenderFns } from "./Specifications.vue?vue&type=template&id=e5abcc08&scoped=true&"
import script from "./Specifications.vue?vue&type=script&lang=ts&"
export * from "./Specifications.vue?vue&type=script&lang=ts&"
import style0 from "./Specifications.vue?vue&type=style&index=0&id=e5abcc08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5abcc08",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsKETable: require('/var/www/packages/theme/components/atoms/KETable.vue').default,MoleculesShowMoreOverlay: require('/var/www/packages/theme/components/molecules/ShowMoreOverlay.vue').default,AtomsAccordion: require('/var/www/packages/theme/components/atoms/Accordion.vue').default})
